import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { errorCss } from '../../../ui/Form/baseStyles/index.styles';

export const suggestionList = css({
  // top: 'unset !important',
  top: 66,
  // marginTop: '-10px',
  width: '100%',
  [MediaQueries.xl]: {},
  [MediaQueries.lg]: {},
  [MediaQueries.md]: {},

  [MediaQueries.sm]: {},
  '.hide-item': {
    display: 'none',
  },
});

export const highlightedSearchResultItemCss = css({
  // outline: `1px solid ${colorsPalette.teal}`,
  boxShadow: `inset 0 0 0px 1px ${colorsPalette.teal}`,
  border: 'none',
});

export const darkSearchResultTextMatchCss = css({
  color: colorsPalette.black,
  fontWeight: 'bold',
});
export const TypeAheadDropDown = css({
  position: 'relative',
  '.typeHeadeInput-holder': {
    div: {
      paddingRight: '0px',
      marginBottom: '10px',

      img: {
        position: 'relative',
        right: '-8px',
      },
    },
  },

  // label: {
  //   fontSize: '16px',
  // },
  ul: {
    border: '1px solid #D9DBDD',
    position: 'absolute',
    borderRadius: '0px 0px 4px 4px',
    zIndex: 1,
    background: '#fff',
    top: '56px',
    width: '100%',
    maxHeight: '350px',
    overflow: 'auto',

    '::-webkit-scrollbar': { width: '5px' },
    '::-webkit-scrollbar-track': { background: 'transparent' },
    '::-webkit-scrollbar-thumb': { background: '#EEF0F2' },
    '::-webkit-scrollbar-thumb:hover': { background: '#EEF0F2' },

    '.group-title': {
      backgroundColor: '#EEF0F2',
      fontSize: '14px',
      lineHeight: '18px',
      textTransform: 'uppercase',
      letterSpacing: '0.875px',
      textAlign: 'left',
      color: '#656566',
      fontWeight: '500',
      marginLeft: '0px',
      marginRight: '0px',
      textTransform: 'uppercase',
      span: {
        paddingLeft: '15px',
      },
    },
    '.view-all-item': {
      backgroundColor: '#EEF0F2',
      fontSize: '16px',
      lineHeight: '24px',
      justifyContent: 'center',
      textTransform: 'none',
      letterSpacing: '0.875px',
      textAlign: 'left',
      marginRight: '0px',
      color: '#E52500',
      fontWeight: '400',
      marginLeft: '0px',

      span: {
        borderBottom: '#E52500 solid 1px',
      },
    },

    '.no-data-found': {
      background: '#EEF0F2',
      marginLeft: '0px',
      marginRight: '0px',
      span: {
        paddingLeft: '15px',
      },
    },

    li: {
      paddingTop: '10px',
      paddingBottom: '10PX',
      borderBottom: '1px solid #D9DBDD',
      cursor: 'pointer',
      display: 'flex',
      fontSize: '16px',
      lineHeight: '32px',
      paddingLeft: '5px',
      paddingRight: '15px',
      marginLeft: '15px',
      marginRight: '15px',

      i: {
        paddingRight: '22px',
      },
    },
  },
  '.TypeAheadDropDown input': {},
  '.TypeAheadDropDown ul::before': { content: "''" },
  '.TypeAheadDropDown ul': {
    listStyleType: 'none',
    textAlign: 'left',
    margin: '0',
    padding: '0',
  },

  '.TypeAheadDropDown li': { padding: '10px 5px', cursor: 'pointer' },
  '.TypeAheadDropDown li:hover': {
    background: 'lightgray',
    textDecoration: 'underline',
  },
  '.App': { margin: '150px auto 0 auto', width: '600px' },
});
